var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"empty"},[_c('img',{attrs:{"src":require("../../assets/img/common/img-empty-icon.png")}}),_c('el-empty',{attrs:{"image-size":_vm.imageSize,"description":_vm.description}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }